import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekStack = styled(Stack)(({ theme }) => ({}));

export { PeekStack, PeekStack as default };
